<template>
	<div class="p-col-12 p-grid">

		<div v-if="!commonService.isMobile()" class="p-col-12 p-lg-6" style="margin: auto">
			<div class="card card-w-title" style="width: 100%;">
				<Toast />
				<div class="p-grid">
					<img :src="commonService.getHomePlayerTransfersImageUrl()" alt="" style="width: 100%">
				</div>
			</div>
		</div>

		<div class="p-col-12 p-lg-6" :class="[commonService.isMobile() ? 'text-box-mobile' : 'text-box']">
			<p>SECURE</p>
			<p class="login-subtitle">Smart Tech</p>
			<p class="login-text justified">At TiroLibre, we prioritize your safety and transparency. That's why we use cutting-edge technologies like Smart Agents and Smart Contracts to create a secure and reliable experience for you.</p>
			<p class="login-text justified">Plus, our platform features a team of dedicated experts available 24/7 to provide personalized support and assistance throughout the entire transfer process.</p>
			<div v-if="!commonService.isMobile()" class="p-lg-3 button-box" style="padding: 0px">
				<Button label="Go for it" class="p-button-warning" style="color: white; font-weight: bold;" @click="toLogin" />
			</div>
		</div>

		<div v-if="commonService.isMobile()" class="p-col-12 p-lg-6" style="margin: auto">
			<div class="card card-w-title" style="width: 100%;">
				<Toast />
				<div class="p-grid">
					<img :src="commonService.getHomePlayerTransfersImageUrl()" alt="" style="width: 100%">
				</div>
			</div>
			<div v-if="commonService.isMobile()" class="p-col-4 button-box-mobile" style="margin-top: -30px; margin-bottom: 30px">
				<Button label="Go for it" class="p-button-warning" style="color: white; font-weight: bold;" @click="toLogin" />
			</div>
		</div>
	</div>
</template>

<script>
import CommonService from "@/service/CommonService";

export default {
	commonService: null,
	created() {
		this.commonService = new CommonService();
	},
	methods: {
		toLogin() {
			this.$router.push("/login");
		},
	},
};
</script>

<style scoped>
.justified {
	text-align: justify;
	text-justify: inter-word;
}

.login-title {
	margin-top: -15px;
	font-size: 65px;
	font-weight: bold;
}

.login-subtitle {
	margin-top: -10px;
	font-size: xx-large;
	font-weight: bold;
}

.login-text {
	margin-top: 10px;
	font-size: 19px;
}

.text-box {
	margin: auto;
	padding-left: 50px;
}

.text-box-mobile {
	margin: auto;
}

.button-box {
	margin-top: 20px;
}

.button-box-mobile {
	margin: auto;
}

@media (min-width: 0px) and (max-width: 1000px) {
	.login-title {
		margin-top: -15px;
		font-size: 45px;
		font-weight: bold;
	}

	.login-subtitle {
		margin-top: -0px;
		font-size: x-large;
		font-weight: bold;
    }

	.login-text {
		margin-top: 10px;
		font-size: 16px;
	}
}
</style>